// extracted by mini-css-extract-plugin
export var emptyState = "_4v-d";
export var statCard = "_4v-c";
export var table = "_4v-0";
export var tableCell = "_4v-4";
export var tableCellClickable = "_4v-5 _4v-4";
export var tableCellDefault = "_4v-6 _4v-4";
export var tableCellEmpty = "_4v-8";
export var tableCellWithValue = "_4v-7";
export var tableContainer = "_4v-e";
export var tableHeaderWeight = "_4v-1";
export var tableHeaderZone = "_4v-2";
export var tableRowHeader = "_4v-3";
export var viewModeButton = "_4v-9";
export var viewModeButtonActive = "_4v-a _4v-9";
export var viewModeButtonInactive = "_4v-b _4v-9";